import axios from "axios";
import { toast } from "sonner";
import { store } from "./storage";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = store.get("ulume_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** Turn any axios/FastAPI error into a short, human-readable message. */
export function errMsg(err, fallback = "Something went wrong. Please try again.") {
  if (!err) return fallback;
  if (err.code === "ECONNABORTED") return "The server took too long to respond. Please try again.";
  if (!err.response) return "Can't reach the server. Check your internet connection.";
  const d = err.response.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) {
    const field = d[0].loc?.[d[0].loc.length - 1];
    return `${field ? `${String(field).replace(/_/g, " ")}: ` : ""}${d[0].msg}`;
  }
  if (err.response.status >= 500) return "Server error. Please try again in a moment.";
  return fallback;
}

// Central error handling so no failed request is silent. Pass { silent: true } to opt out.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    const status = err.response?.status;
    if (status === 401 && !url.startsWith("/auth/login")) {
      if (store.get("ulume_token")) {
        store.remove("ulume_token");
        window.dispatchEvent(new Event("ulume:logout"));
        if (!url.startsWith("/auth/me")) toast.error("Your session expired. Please sign in again.");
      }
    } else if (!err.config?.silent && !url.startsWith("/auth/")) {
      toast.error(errMsg(err));
    }
    return Promise.reject(err);
  }
);
